/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

import { accessToken } from '../lib/access.js';
import { getConfig } from '../lib/config.js';
import { t } from '../lib/i18n.js';
import { injectParams } from '../lib/links.js';
import { stripHTML } from '../lib/text.js';

export function init() {
        var cfg = getConfig() || {};
        const btn = document.querySelector('.toc-button');
        const btnIn = document.querySelector('.toc-button-inner');
        const box = document.querySelector('.toc-box');
        const panel = document.querySelector('.toc-content');
        const closeBtn = document.querySelector('.toc-box .map-button');
        if (!box || !panel) return;
        const dropped = 'dropped';
        const open = () => {
            btn.classList.add(dropped);
            box.classList.add(dropped);
            btn?.setAttribute('aria-expanded', 'true');
        };
        const close = () => {
            btn.classList.remove(dropped);
            box.classList.remove(dropped);
            btn?.setAttribute('aria-expanded', 'false');
        };
        if (btn) btn.addEventListener('click', open);
        if (btnIn) btnIn.addEventListener('click', close);
        if (closeBtn) closeBtn.addEventListener('click', close);
        document.addEventListener('click', (e) => {
            if (!box.classList.contains(dropped)) return;
            if (!box.contains(e.target) && !btn.contains(e.target)) close();
        });

        const fmt = (item) => {
            if (item.type === 'section') {
                const list = (item.items || []).map(fmt).join('');
                return `<div class="list-wrapper"><p class="js-list-toggle toc-item-header">${item.title}</p><ul${item.className ? ` class="${item.className}"` : ''}>${list}</ul></div>`;
            } else if (item.type === 'subsection') {
                const list = (item.items || []).map(fmt).join('');
                // The icon was the whole link, so it had no name at all
                // and read as its own URL. The name says which section it
                // downloads, because a list of them is otherwise a row of
                // identical links.
                const dl = item.downloadURL
                    ? `<a class="toc-item-download" href="${item.downloadURL}"><i class="fas fa-download" aria-hidden="true"></i><span class="sr-only">${t('a11y.downloadSection', { section: stripHTML(item.title) })}</span></a>`
                    : '';
                return `<li><p class="toc-item-subhead"><span>${item.title}</span>${dl}</p><ul${item.className ? ` class="${item.className}"` : ''}>${list}</ul></li>`;
            } else {
                if (item.html?.length)
                    return `<li${
                        item.className ? ` class="${item.className}"` : ''
                    }>${item.html}</li>`;
                if (item.url) {
                    const mapUrl = new URL(window.location.href);
                    const itemUrl = new URL(item.url, window.location.href);
                    if (mapUrl.host === itemUrl.host)
                        itemUrl.search = mapUrl.search;
                    item.url = itemUrl.toString();
                }
                let h2 = `<li>${item.url ? `<a href="${item.url}">` : ''}<span class="toc-item-title">${item.title}</span>${item.subhead ? `<span class="toc-item-subhead">${item.subhead}</span>` : ''}${item.url ? '</a>' : ''}`;
                if (item.children?.length) {
                    h2 += `<ul>${item.children.map(fmt).join('')}</ul>`;
                }
                return `${h2}</li>`;
            }
        };
        const tocURL = injectParams(cfg.endpoints.toc, {
            // In the address rather than left to the cookie: a map
            // embedded in someone else's page is a cross-site request,
            // and the browser withholds it there.
            access: accessToken(),
            lang: cfg.i18n.lang,
            preview: cfg.map.isPreview ? 1 : null
        });
        (async () => {
            try {
                const r = await fetch(tocURL, { credentials: 'same-origin' });
                if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
                const toc = await r.json();
                panel.innerHTML = (toc.sections || []).map(fmt).join('');
                // glossary mini-accordion (native)
                [...panel.querySelectorAll('.glossary li')].forEach((li) => {
                    li.addEventListener('click', () => {
                        const on = li.classList.contains('active');
                        [...panel.querySelectorAll('.glossary li')].forEach(
                            (n) => n.classList.remove('active')
                        );
                        if (!on) li.classList.add('active');
                    });
                });
                // list sections (native)
                [...panel.querySelectorAll('.js-list-toggle')].forEach(
                    (header) => {
                        header.addEventListener('click', () => {
                            const wrapper = header.parentNode;
                            const on = wrapper.classList.contains(dropped);
                            [
                                ...panel.querySelectorAll('.list-wrapper')
                            ].forEach((w) => w.classList.remove(dropped));
                            if (!on) wrapper.classList.add(dropped);
                        });
                    }
                );
                // link click closes box
                [...panel.querySelectorAll('a')].forEach((a) => {
                    a.addEventListener('click', () => {
                        a.classList.add('visited');
                        close();
                    });
                });
            } catch (e) {
                console.error('Error loading table of contents:', e);
            }
        })();
}
